
import PageTab from "components/common/pageTab";
import TopImage from "components/common/topImage";
import ImgUrl from 'assets/images/business.png';

import 'assets/css/distribution.scss';

import { pageMenuTabList02 } from 'types/common';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

const B2B = () => {
  
  const productTypeProp = [    
    { tabText: '치어팩 [M방형]', text: '액상팩 : 40~200 mL<br/>워터젤리 : 40~150 g', url:'https://img.chunhomall.com/images/brand_site/oemodm-section-01_300x300.png' },
    { tabText: '치어팩 [스탠딩]', text: '액상팩 : 40~200 mL<br/>워터젤리 : 40~150 g', url:'https://img.chunhomall.com/images/brand_site/oemodm-section-02_300x300.png' },
    { tabText: '치어팩 [안전캡]', text: '액상팩 : 40~200 mL', url:'https://img.chunhomall.com/images/brand_site/oemodm-section-03_300x300.png' },
    { tabText: '사면포', text: '액상팩 : 40~80 mL', url:'https://img.chunhomall.com/images/brand_site/oemodm-section-04_300x300.png' },
    { tabText: '스틱포', text: '액상스틱 : 10~20 mL<br/>젤리스틱 : 15~25 g', url:'https://img.chunhomall.com/images/brand_site/oemodm-section-05_300x300.png' },
    { tabText: '소(小)환', text: '소환 : 3~4 g/포', url:'https://img.chunhomall.com/images/brand_site/oemodm-section-06_300x300.png' },
    { tabText: '대(大)환', text: '대환 : 4.0~4.5 g', url:'https://img.chunhomall.com/images/brand_site/oemodm-section-07_300x300.png' },
    { tabText: '바이알', text: '용량 20~30mL', url:'https://img.chunhomall.com/images/brand_site/product-section-vial-06.png' },
    { tabText: '멀티캡 바이알', text: '용량 20~30mL', url:'https://img.chunhomall.com/images/brand_site/product-section-vial-02.png' },
    { tabText: '멀티캡 치어팩', text: '용량 50~150mL', url:'https://img.chunhomall.com/images/brand_site/product-section-vial-05.png' },
  ];

  pageMenuTabList02[0].on = true;
  const step1Rendering = () => {
    const result = [];
    for (let i = 1; i <= 7; i++) {
      const urlIndex = i < 10 ? '0' + i : i;
      result.push(
        <div className="img-style" key={i}>
          <img src={`https://img.chunhomall.com/images/brand_site/oemodm-section-${urlIndex}_300x300.png`} alt="Research Image" />
        </div>
      );
    }
    return result;
  }
  const productTypeRendering = () => {
    const result = [];
    for (let i = 0; i < productTypeProp.length; i++) {
      result.push(
        <div className="img-style">
          <div className="img-inner bgF7F7F7">
            <img src={productTypeProp[i].url} alt="Research Image" />
            <div className="img-inner-text">
              {productTypeProp[i].tabText}
            </div>
          </div>
          <div className="img-text">
            <div dangerouslySetInnerHTML={{__html: productTypeProp[i].text}}></div>
          </div>
        </div>
      );
    }
    return result;
  }
  return (
    <div className="page_content">
      <TopImage imgUrl="https://img.chunhomall.com/images/brand_site/oemodm-hero_1920x1080.jpg.jpg" imgText="사업소개" textcolor="#FFF"></TopImage>
      <PageTab props={pageMenuTabList02}></PageTab>
    
      <div className="distribution">
        <div className="container">
          <div className="container-title">
            천호엔케어는<br/>
            고객사가 원하는 방향을 정확하게 파악하여<br/>
            <span className="highlight">최고의 품질로 최상의 서비스를 제공</span>합니다.
          </div>
        </div>

        <div className='banner-wrapper'>
          <div className='distribute-banner'>
            <img src={`https://img.chunhomall.com/images/brand_site/oemodm-section_1240x600.jpg.jpg`} alt=" Image" />
            <div className='title'>
              <div className='title-text'>
                천호엔케어 <span className="highlight">B2B 사업제안</span>
              </div>
              
              {/* <div className='sub-title'>천호엔케어는 치어팩 설비라인 5대를 비롯하여 총 11대의 설비기계로 대량 생산이 가능하며 합리적인 생산수량을 제공합니다.</div>
              <div className="sub-title">스틱포, 사면포, 치어팩 스탠딩, 치어팩 M방형, 대환, 소환의 총 6가지 제형으로 제작 가능합니다.</div> */}
              <div className="sub-title">문의처 : b2b@chunhoncare.com</div>
              
              <div className='title-btn'>
                <div className="btn-step"></div>
                <div className="btn-text"><a href="https://img.chunhomall.com/page/doc/chunhoNcare_2026.pdf" style={{color: '#FFF'}} target="_blank" download>회사소개서 내려받기 <FontAwesomeIcon icon={faDownload} /></a></div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="container-item">
            <div className="container-item-title">OEM/ODM 절차</div>
          </div>
          <div className="b2b-process" style={{margin:"20px 0 50px 0"}}>
            <img className="img-pc" src="https://img.chunhomall.com/images/brand_site/oemodm-section-02_1920x340.png.png" alt=""></img>
            <img className="img-mo" src="https://img.chunhomall.com/images/brand_site/m-oemodm-section-02_400x860.png.png" alt=""></img>
          </div>
        </div>
        <div className="container">
          <div className="container-item">
            <div className="container-item-title">생산 품목</div>
            <div className="container-item-desc">
              
            </div>
            <div className='container-img-grid type21'>
              {productTypeRendering()}
              
              
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default B2B;